export default {

    'dashboard': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/dashboard/_configuracoes/stores').default
        },
    },

    'usuarios': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/usuarios/_configuracoes/stores').default
        },
    },

    'ajuda': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/ajuda/_configuracoes/stores').default
        },
    },

    'encartes': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/encartes/_configuracoes/stores').default
        },
    },

    'encartes-virtuais': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/encartes-virtuais/_configuracoes/stores').default
        },
    },

    'box': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/box/_configuracoes/stores').default
        },
    },

    'midias-sociais': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/midias-sociais/_configuracoes/stores').default
        },
    },

    'artes-digitais': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/artes-digitais/_configuracoes/stores').default
        },
    },

    'acoes-whatsapp': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/acoes-whatsapp/_configuracoes/stores').default
        },
    },

    'boas-praticas': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/boas-praticas/_configuracoes/stores').default
        },
    },

    'banco-de-midias': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/banco-de-midias/_configuracoes/stores').default
        },
    },

    'material-de-apoio': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/material-de-apoio/_configuracoes/stores').default
        },
    },

    'feedback': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/feedback/_configuracoes/stores').default
        },
    },

    'relatorios': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/relatorios/_configuracoes/stores').default
        },
    },

    'comunicados': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/comunicados/_configuracoes/stores').default
        },
    },

    'cartas-de-planejamento': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/cartas-de-planejamento/_configuracoes/stores').default
        },
    },

    'logistica': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/logistica/_configuracoes/stores').default
        },
    },

    'administracao': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/administracao/_configuracoes/stores').default
        },
    },

    'pesquisa-de-campo': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/pesquisa-de-campo/_configuracoes/stores').default
        },
    },

}
